import { z } from "zod";

const translationPath = "page.changePin.errors.";

const pinRegex = /^\d{4}$/;

export const changePinSchema = z
  .object({
    newPin: z
      .string()
      .nonempty(translationPath + "new_pin")
      .regex(pinRegex, translationPath + "pin_format"),
    confirmNewPin: z.string().nonempty(translationPath + "confirm_new_pin"),
  })
  .superRefine((val, ctx) => {
    if (val.newPin !== val.confirmNewPin) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "pins_match",
        path: ["confirmNewPin"],
      });
    }
  });

export type TChangePinForm = z.infer<typeof changePinSchema>;
